import * as Yup from 'yup';
import moment from 'moment';
import { momentDateSchemaType } from '@validations/moment';

export const SingleDayTimeSlotConfigurationSchema: Yup.AnySchema = Yup.object().shape({
  startTime: momentDateSchemaType
    .required('Start time is required')
    .test(
      'startTime',
      'Start time should not be greater than or equal to the end time.',
      function timeSlotStartTimeValidation(value) {
        const endTime = moment(this.parent.endTime);

        return endTime > moment(value);
      },
    ),
  endTime: momentDateSchemaType.required('End time is required'),
  interval: Yup.boolean(),
});

export const TimeSlotConfigurationsSchema: Yup.AnySchema = Yup.object().shape({
  // eslint-disable-next-line react/forbid-prop-types
  monday: Yup.array(SingleDayTimeSlotConfigurationSchema),
});
